import type { ApiResult, PortalContext } from '../types';

const post = async (path: string, body: object): Promise<ApiResult> => {
  const res = await fetch(path, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  const json = await res.json().catch(() => ({})) as Record<string, unknown>;
  return { ok: res.ok, status: res.status, json };
};

export const postFree    = (ctx: PortalContext)               => post('/auth/free',    { clientMac: ctx.clientMac, apMac: ctx.apMac, ssid: ctx.ssid });
export const postVoucher = (ctx: PortalContext, code: string) => post('/auth/voucher', { clientMac: ctx.clientMac, apMac: ctx.apMac, ssid: ctx.ssid, code });
